import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";

import eth1 from "../../assets/Images/ethical/1.png";
import eth2 from "../../assets/Images/ethical/3.png";
import eth3 from "../../assets/Images/ethical/2.png";



import Slideshow from "../../assets/Slideshow/Slideshow"; 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";





const Lo4Eth = () => {
    const navigate = useNavigate();
    const images = [eth1, eth2, eth3];

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo4-headings">
                <h1>Ethical Consideration</h1>
                <p></p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                                <BreadcrumbHeader />
                        </div>
            <div className="content-lo4">
                <div className="content-lo4-ethical">
                    <div className="content-lo4-ethical-text">
                        <h2>The use of AI</h2>
                        <p>
                            During this semester, I used ChatGPT to support my work in technical, and creative aspecets for example:
                            <ul>
                                <li>
                                    I generate image icons for my subtopics for my learning outcome, I do this because it saves time and also I want to try generating icon
                                    visual that maintain it's style. Personally I do this to experiment if this type of image/visual would look good if I use it as an icon for the subtopic.
                                </li>
                                <li>
                                    When I tried to moved my arduino code from Arduino IDE to VS Code, I encounter a problem, I went to ChatGPT to check and ask for instruction on
                                    how to resolve this, I was given step-by-step on how to properly solve this errors.
                                </li>
                            </ul>
                            AI played a supporting role but I make sure to use it thoughtfully, making sure it aligned with my goals and ethical standards. In terms of the originality the images
                            were generated and guided by my own ideas and input, while for the privacy I did not share any personal or sensitive information.
                            <h2>Ethical Reflection on AI and My Learning Process</h2>
                            <p>
                                While AI was helpful, using it made me reflect on my own learning process. I realized that if I relied too much on AI, I might skip valuable opportunities to build deeper
                                problem solving skills. That's why I treated AI more as a guide than a solution. For example, when troubleshooting with ChatGPT, I didn't just follow instructions blindly,
                                I took time to understand each step and researched terms I didn't know.
                            </p>
                            <p>
                                This approach helped me stay active in my own learning. Ethically, I see it as important to stay in control of the creative and technical decisions, rather than letting AI
                                do the thinking for me. By using AI critically, I could explore new possibilities while still developing my own skills and understanding.
                            </p>
                        </p>
                        <h2>Cultural ethical considerations on where is the limit of influential marketing</h2>
                        <p>
                            The research uses Octolume's interactive campaign for Fontys University as a real-world case study to examine the moral and cultural bounds of powerful marketing in education.
                            The campaign successfully drew in Gen Z students with its use of cat memes, Arduino-powered 3D posters, and humorous engagement strategies. But it also brought up deeper concerns
                            with ethical design, cultural sensitivity, and manipulation. The study highlights how creativity, openness, and cultural sensitivity must cooperate to guarantee ethical marketing
                            practices, particularly in different educational settings, by combining campaign findings with academic sources.
                        </p>
                        <p>
                            Here is the link to the document: {""}
                             <a 
                                href="/docs/cultural.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                             >Cultural Ethical Consideration Report
                             </a>
                        </p>
                    </div>

                    <div className="content-lo4-ethical-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo4Eth;